export enum SellerSummaryEnrollmentStatus {
    /** 0 [(lsq.common.annotations.enum_display_name) */
    UNKNOWN = 'UNKNOWN',
    /** 1 [(lsq.common.annotations.enum_display_name) */
    ENROLLED = 'ENROLLED',
    /** 2 [(lsq.common.annotations.enum_display_name) */
    NOT_ENROLLED = 'NOT_ENROLLED',
    /** 3 [(lsq.common.annotations.enum_display_name) */
    INELIGIBLE = 'INELIGIBLE'
}
